// extracted by mini-css-extract-plugin
export default {"star":"_2Zm6kj-MAaQitJvUFyHZMO"};